import moment from 'moment';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table'; // see https://github.com/xaksis/vue-good-table
import 'vue-good-table/dist/vue-good-table.css';
import { Component } from 'vue-property-decorator';
import { SearchResult, SuperSearch } from './search.model';
import SearchmodalService from './searchmodal.service';
import { formatDateTimeSeconds } from "../../util";

@Component(
    {
        name: 'searchmodal',
        components: {
            filterbar: require('../filterbar/filterbar.vue.html').default,
            VueGoodTable
        }
    })
export default class SearchmodalComponent extends Vue {
    service: SearchmodalService = new SearchmodalService();
    results: SearchResult[] = [];

    columnsConfig = [
        {
            label: this.getStrTime(),
            field: (e: SearchResult) => formatDateTimeSeconds(e.lastModified as Date),
            sortFn: (_1, _2, _3, l: SearchResult, r: SearchResult) => {
                return (l.lastModified as Date).getTime() - (r.lastModified as Date).getTime();
            }
        },
        {
            label: 'Type',
            field: 'type',
        },
        {
            label: this.getStrContent(),
            field: 'content'
        }
    ];

    constructor() {
        super();
    }

    mounted() {
        console.log('SearchModale mounted');
    }

    onFilterHit(data) {
        // child-> parent https://stackoverflow.com/questions/43334796/pass-data-from-child-to-parent-in-vuejs-is-it-so-complicated
        console.log("on filter by child data=" + data);
        var query = new SuperSearch();
        query.filter = data;
        this.service.postSearch(query)
            .then(data => {
                this.results = data as SearchResult[];
                this.results.forEach(e => e.lastModified = new Date(e.lastModified))
            });
    }

    formatDate(value) {
        //console.log("date=" + value);
        let fmt2 = 'D MMM YYYY hh:mm';
        return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DDThh:mm').format(fmt2)
    }

    getStrTime() {
        return this.$i18n.t('txtTime').toString();
    }

    getStrContent() {
        return this.$i18n.t('txtContent').toString();
    }

}